<!-- Contenedor carrusel -->
<app-banner-carousel></app-banner-carousel>
<!-- Fin carrusel -->

<!-- Contenedor info cursos comunidad -->


<!-- <div class="p-grid p-m-0 p-jc-center p-ai-center p-px-4 p-px-md-3 p-py-5 p-py-md-6 bg-blanco">
  <div class="p-col-12 p-sm-5 p-md-6 p-lg-5 p-xl-3 p-sm-4 p-md-3 p-lg-3 p-xl-3 p-text-left">
    <img width="100%" src="assets/images/cursos_comunidad.svg" />
  </div>
  <div class="p-col-12 p-sm-7 p-md-6 p-lg-6 p-xl-4 p-sm-5 p-md-4 p-lg-4 p-xl-4">
    <h1>Cursos para toda la comunidad</h1>
    <p>Revisa los cursos gratuitos y para empresas que tenemos disponibles, podrás obtener una certificación al aprobar el curso.</p>
    <div class="p-mt-4">
      <button pButton icon="pi pi-search" label="Ir a ver todos los cursos" class="btn-primary" routerLink="/cursos-ofertados">
      </button>
    </div>
  </div>
</div>  -->


<!-- Fin cursos comunidad -->


<!-- Contenedor cursos recomendados -->
<div id="cursos" class="bg-azul">
  <div class="p-grid p-jc-center p-m-0" style="background-color: transparent; z-index: 99; position: relative;">
    <div class="p-col-12 p-sm-11 p-md-11 p-lg-10 p-xl-7 p-offset-1 p-py-3 py-md-4 p-px-3 p-m-0 p-text-center">
      <h1 class="p-mr-3">Cursos <span style="font-weight: 700;">Recomendados</span></h1>
      <p @fadeInUp>Estos son algunos de los cursos ofrecidos en nuestra plataforma.</p>
    </div>
    <div class="p-col-12 p-sm-11 p-md-11 p-lg-10 p-xl-8 p-offset-1 p-pb-2 p-m-0 p-px-3">
      <p-tabView>
        <p-tabPanel header="Cursos activos">
          <app-cursos-carousel [cursos]="cursosDisponibles" [circular]="false" [itemsPerPage]="4" [autoplayInterval]="null"></app-cursos-carousel>
        </p-tabPanel>
        <p-tabPanel header="Cursos no disponibles">
          <app-cursos-carousel [cursos]="cursosNoDisponibles" [circular]="false" [itemsPerPage]="4" [autoplayInterval]="null"></app-cursos-carousel>
        </p-tabPanel>
    </p-tabView>
    </div>
  </div>
  <div class="wave">
     <img src="assets/images/wave.svg" />
  </div>
</div>
<!-- Fin cursos recomendados -->

<!-- Contenedor inicio sesión -->
<div class="p-grid p-m-0 p-jc-center p-ai-center p-px-4 p-px-md-3 p-py-5 p-py-md-6 bg-gris">
  <div class="p-col-9 p-sm-5 p-md-4 p-lg-3 p-xl-3 p-d-block p-d-md-none p-text-center">
    <img width="100%" src="assets/images/inicio_sesion.svg" />
  </div>
  <div *ngIf="!sessionService.isLogged()" class="p-col-12 p-sm-6 p-md-6 p-lg-6 p-xl-4 p-offset-0 p-offset-md-1 p-py-4 p-py-md-6">
    <h1>Si ya tienes una cuenta, inicia sesión</h1>
    <p>
      Ingresa a tu cuenta para continuar con uno de los cursos en los que hayas postulado, o bien si estás deseando postular en un nuevo curso.<br><br>
      <small class="text-muted">Si ya habías postulado a un curso, no podrás registrarte nuevamente, deberás iniciar sesión primero.</small>
    </p>
    <button routerLink="/login" icon="pi pi-sign-in" pButton label="Ir al inicio de sesión" class="btn-primary"></button>
  </div>
  <div *ngIf="sessionService.isLogged()" class="p-col-12 p-sm-6 p-md-6 p-lg-6 p-xl-4 p-offset-0 p-offset-md-1 p-py-4">
    <h1>Hola, ya puedes ingresar a tu cuenta</h1>
    <p>
      Accede a tu cuenta para realizar los cursos en los que hayas postulado. Recuerda que puedes postular a los demás cursos que tenemos disponibles para ti.<br><br>
      <small class="text-muted">Recuerda que puedes cerrar tu sesión desde tu cuenta.</small>
    </p>
    <button routerLink="/micuenta/dashboard" icon="pi pi-sign-in" pButton label="Ir a mi cuenta" class="btn-secondary"></button>
  </div>
  <div class="p-col-6 p-sm-5 p-md-5 p-lg-4 p-xl-3 p-d-none p-d-md-block p-text-center">
    <img width="100%" src="assets/images/inicio_sesion.svg" />
  </div>
</div>
<!-- Fin inicio sesión -->




<!-- Contenedor videos -->
<div class="p-grid p-m-0 p-jc-center p-px-4 p-px-md-3 p-py-5 p-py-md-6 bg-blanco">
  <div class="p-col-12 p-d-flex p-flex-column p-text-center">
    <h1>Videos tutoriales de acceso</h1>
    <p class="p-m-0">Revisa cómo funciona nuestra plataforma y atrévete.</p>
  </div>
  <div class="p-grid grid-videos p-jc-center">
    <div class="p-col-12 p-sm-6 p-md-4 p-lg-6 p-xl-4 p-mt-4" *ngFor="let video of videos" style="min-width: 320px">
      <iframe class="youtube-player" width="100%" [src]="video.url" title="Video tutorial Educación Continua" frameborder="0" allowfullscreen></iframe>
    </div>
  </div>
</div>
<!-- Fin contenedor videos -->

<!-- Contenedor estadísticas sitio -->
<div class="p-grid p-m-0 p-jc-center p-px-4 p-px-md-3 p-py-5 p-py-md-6 bg-gris text-secondary">
  <div class="p-col-12 p-text-center p-pb-4">
    <h1 style="font-weight: 700; font-size: 1.4rem;">Nuestro alcance</h1>
    <p>Revisa lo que hemos logrado a través de nuestra plataforma</p>
  </div>
  <div class="p-col-4 p-sm-4 p-md-3 p-lg-3 p-xl-2 p-d-flex p-flex-column p-text-center">
    <h2 class="p-m-0" style="font-size: 2rem;">{{numCursosGratuitos}}+</h2>
    <p class="p-m-0">Cursos gratuitos</p>
  </div>
  <div class="p-col-4 p-sm-4 p-md-3 p-lg-3 p-xl-2 p-d-flex p-flex-column p-text-center">
    <h2 class="p-m-0" style="font-size: 2rem;">{{numPostulantes}}+</h2>
    <p class="p-m-0">Usuarios inscritos</p>
  </div>
  <div class="p-col-4 p-sm-4 p-md-3 p-lg-3 p-xl-2 p-d-flex p-flex-column p-text-center">
    <h2 class="p-m-0" style="font-size: 2rem;">{{numCertificados}}+</h2>
    <p class="p-m-0">Certificados entregados</p>
  </div>

</div>



<!-- Contenedor preguntas frecuentes -->
<app-preguntas-frecuentes></app-preguntas-frecuentes>
<!-- Fin preguntas frecuentes -->